import type { CreativeBriefResponse } from '@innovationdepartment/proxima-sdk-axios';
import CopyVariationItem from './CopyVariationItem';
import PanelAccordion from './PanelAccordion';

type AccordionSectionsProps = {
  brief: CreativeBriefResponse;
};

const AccordionSections = ({ brief }: AccordionSectionsProps) => (
  <>
    {brief.bodyCopyVariations.length > 0 && (
      <PanelAccordion title="Body Copy Options">
        {brief.bodyCopyVariations.map((text, i) => (
          <CopyVariationItem key={`body-${text}`} text={text} index={i} />
        ))}
      </PanelAccordion>
    )}

    {brief.textOverlayOptions.length > 0 && (
      <PanelAccordion title="Text Overlay Options">
        {brief.textOverlayOptions.map((text, i) => (
          <CopyVariationItem key={`overlay-${text}`} text={text} index={i} />
        ))}
      </PanelAccordion>
    )}

    <PanelAccordion title="Campaign Hook & CTA">
      <CopyVariationItem text={brief.primaryHook} index={0} />
      <CopyVariationItem text={brief.callToAction} index={1} />
    </PanelAccordion>
  </>
);

export default AccordionSections;
